import { createSelector } from 'reselect'

export const getNeedResetPhotos = createSelector(
  state => state && state.ads && state.ads.shared && state.ads.shared.resetPhotos,
  resetPhotos => resetPhotos
)
